import { type TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import type { GradeSelectorDispatchType, GradeSelectorStateType } from "./store";
import type { GradeSelectorCategoryType } from "./slices/GradeSelectorFiltersSlice";

export const useGradeSelectorDispatch = (): GradeSelectorDispatchType => useDispatch<GradeSelectorDispatchType>();
export const useGradeSelectorSelector: TypedUseSelectorHook<GradeSelectorStateType> = useSelector;

export const useGradeSelectorFilterCategory = (): (GradeSelectorCategoryType & {
    fullPath: string;
    root: string;
})[] => {
    const categories = useGradeSelectorSelector((state) => state.gradeSelectorFilters.category);

    if (!categories || !Object.keys(categories).length) return [];

    const activeCategories = Object.keys(categories)
        .filter((key) => categories[key].active === true)
        .map((activeCategoryKey) => {
            const subCategory = categories[activeCategoryKey]?.subCategory;
            return {
                ...categories[activeCategoryKey],
                fullPath: `${activeCategoryKey}${subCategory ? `/${subCategory}` : ""}`,
                root: activeCategoryKey,
            };
        });

    return activeCategories;
};
